import type { IconName } from '@/components/Icon/types'

export const statSizes = ['sm', 'md', 'lg', 'xl', '2xl', '3xl'] as const
export type StatSize = (typeof statSizes)[number]

export const statFormats = ['default', 'compact'] as const
export type StatFormat = (typeof statFormats)[number]

export type StatArgs = {
  icon?: IconName
  value: string | number
  label: string
  size?: StatSize
  format?: StatFormat
}
